/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The operating mode for an account.
 */
export const Mode = {
  Sandbox: "sandbox",
  Production: "production",
} as const;
/**
 * The operating mode for an account.
 */
export type Mode = ClosedEnum<typeof Mode>;

/** @internal */
export const Mode$inboundSchema: z.ZodNativeEnum<typeof Mode> = z.nativeEnum(
  Mode,
);
/** @internal */
export const Mode$outboundSchema: z.ZodNativeEnum<typeof Mode> =
  Mode$inboundSchema;
